import { createActions } from 'src/utils/reduxUtils'

export const FetchPartner = createActions('FetchPartner')
export const FetchDriver = createActions('FetchDriver')
export const SetAuthToken = createActions('SetAuthToken')
export const Logout = createActions('Logout')
export const SignInPhone = createActions('SignInPhone')
export const SignInEnterCode = createActions('SignInEnterCode')
export const SignInResendCode = createActions('SignInResendCode')
export const SignUp = createActions('SignUp')
export const SetIsTokenSignIn = createActions('SetIsTokenSignIn')
export const SetValidateLockedUntil = createActions('SetValidateLockedUntil')
export const UploadVehicleInsurance = createActions('UploadVehicleInsurance')
export const UploadInsuranceDeclaration = createActions('UploadInsuranceDeclaration')
export const UploadVehicleRegistration = createActions('UploadVehicleRegistration')
export const UploadVaccination = createActions('UploadVaccination')
export const UploadPaymentMethod = createActions('UploadPaymentMethod')
export const FetchPaymentMethod = createActions('FetchPaymentMethod')
export const UploadInsuranceBeneficiary = createActions('UploadInsuranceBeneficiary')
export const UploadSignContract = createActions('UploadSignContract')
export const UploadBGC = createActions('UploadBGC')
export const UploadMVR = createActions('UploadMVR')
export const UploadEIN = createActions('UploadEIN')
export const UploadForm = createActions('UploadForm')
export const FetchPersonaInquiry = createActions('FetchPersonaInquiry')
export const SetPersonaSessionToken = createActions('SetPersonaSessionToken')
export const SetPersonaClientCompletedInquiry = createActions('SetPersonaClientCompletedInquiry')
export const SetPersonaStarted = createActions('SetPersonaStarted')
export const FetchYardstikReport = createActions('FetchYardstikReport')
export const DocusignStartSigning = createActions('DocusignStartSigning')
export const DocusignCompleteSigning = createActions('DocusignCompleteSigning')
export const DocusignDeclineSigning = createActions('DocusignDeclineSigning')
export const SetNewDocsUploaded = createActions('SetNewDocsUploaded')
export const UploadInsuranceCoverage = createActions('UploadInsuranceCoverage')
export const FetchOptOutProducts = createActions('FetchOptOutProducts')
export const ValidateMCNumber = createActions('ValidateMCNumber')
export const UploadMCNumber = createActions('UploadMCNumber')
export const ValidateUSDOTNumber = createActions('ValidateUSDOTNumber')
export const UploadUSDOTNumber = createActions('UploadUSDOTNumber')
export const UploadDOTNumber = createActions('UploadDOTNumber')
export const UploadDebitCard = createActions('UploadDebitCard')
export const UploadBankInformation = createActions('UploadBankInformation')
export const SkipStep = createActions('SkipStep')
export const UploadSSN = createActions('UploadSSN')
export const CombinedUploadSSN = createActions('CombinedUploadSSN')
export const ManualUploadSSN = createActions('ManualUploadSSN')
export const SubmitTemporaryDriverLicense = createActions('SubmitTemporaryDriverLicense')

export const FetchDocusignSigningEnvelopeOptions = createActions(
  'FetchDocusignSigningEnvelopeOptions',
)
export const FetchPartnerPublicInfo = createActions('FetchPartnerPublicInfo')
export const FetchPublicOpportunity = createActions('FetchPublicOpportunity')
export const FetchRemoteConfig = createActions('FetchRemoteConfig')
export const SubmitOpportunityApplication = createActions('SubmitOpportunityApplication')

// contractor portal
export const ContractorPortalFetchPartner = createActions('ContractorPortalFetchPartner')
export const ContractorPortalFetchDriver = createActions('ContractorPortalFetchDriver')
export const ContractorPortalSetAuthToken = createActions('ContractorPortalSetAuthToken')
export const ContractorPortalLogout = createActions('ContractorPortalLogout')
export const ContractorPortalSignInPhone = createActions('ContractorPortalSignInPhone')
export const ContractorPortalSetValidateLockedUntil = createActions(
  'ContractorPortalSetValidateLockedUntil',
)
export const ContractorPortalFetchPartners = createActions('ContractorPortalFetchPartners')
export const ContractorPortalFetchInvoices = createActions('ContractorPortalFetchInvoices')
export const ContractorPortalFetchInvoice = createActions('ContractorPortalFetchInvoice')
export const ContractorPortalFetchDocuments = createActions('ContractorPortalFetchDocuments')
export const ContractorPortalFetchCertificates = createActions('ContractorPortalFetchCertificates')
export const ContractorPortalDownloadCertificate = createActions(
  'ContractorPortalDownloadCertificate',
)
export const ContractorPortalSignInEnterCode = createActions('ContractorPortalSignInEnterCode')
export const ContractorPortalSignInResendCode = createActions('ContractorPortalSignInResendCode')
export const ContractorPortalSwitchPartner = createActions('ContractorPortalSwitchPartner')
export const ContractorPortalSendCode = createActions('ContractorPortalSendCode')
export const ContractorPortalVerifyCode = createActions('ContractorPortalVerifyCode')
export const ContractorPortalUpdatePhoneSendCode = createActions(
  'ContractorPortalUpdatePhoneSendCode',
)
export const ContractorPortalUpdatePhone = createActions('ContractorPortalUpdatePhone')
export const ContractorPortalUpdateEmailSendCode = createActions(
  'ContractorPortalUpdateEmailSendCode',
)
export const ContractorPortalUpdateEmail = createActions('ContractorPortalUpdateEmail')
export const ContractorPortalUploadBankInformation = createActions(
  'ContractorPortalUploadBankInformation',
)
export const ContractorPortalUploadDebitCard = createActions('ContractorPortalUploadDebitCard')

export const FetchNhtsaDecodedVin = createActions('FetchNhtsaDecodedVin')

export const FetchLMSTrainingState = createActions('FetchLMSTrainingState')
export const CompleteLMSTrainingStep = createActions('CompleteLMSTrainingStep')
export const UploadLMSCertificate = createActions('UploadLMSCertificate')

export const SetDriver = createActions('SetDriver')
export const SetPartner = createActions('SetPartner')
export const SelectRecollectionStep = createActions('SelectRecollectionStep')
